/**
 * Reset Password page - same layout as Login/Signup (header, main, footer).
 */

import React from 'react';
import ResetPasswordComponent from '../../components/auth/ResetPassword';
import { PublicHeader, PublicFooter } from '../../components/public';

const ResetPassword = () => (
  <div className="auth-page-layout">
    <PublicHeader />
    <main className="auth-page-main">
      <ResetPasswordComponent />
    </main>
    <PublicFooter />
  </div>
);

export default ResetPassword;
